import { __extends } from "tslib";
import BSSSwiperTabsAnimations from './bss-swiper-tabs-animations';
import BSSCheckboxProductTypeSwitchComponent from '../../bss-checkbox-component/js/bss-checkbox-component--product-type-switch';
import { prepareProducts, sortByPosition, } from '@main/core/bss-connector/js/parse-request';
import { isEmpty, cloneDeep } from 'lodash';
import logger from '@main/externals/bss-package-logger/js/logger';
var BSSSwiperTabsProductTypeSwitch = /** @class */ (function (_super) {
    __extends(BSSSwiperTabsProductTypeSwitch, _super);
    /**
     * BSSSwiperTabsProductTypeSwitch constructor
     * @param {Object} _entityTemplate simulator template
     * @param {String} containerSelector container selector of components
     * @param {Object} config configuration object
     * @param {EventManager} eventManager instance of _EventManager
     * @param {Formatter} formatter instance of Formatter
     * @param {Resolution} resolution device Resolution
     * @param {Object} toolbox
     */
    function BSSSwiperTabsProductTypeSwitch(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        return _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) || this;
    }
    Object.defineProperty(BSSSwiperTabsProductTypeSwitch.prototype, "_isProductTypeSwitchVisible", {
        /**
         * @desc return visibility state for switch component
         * @returns {boolean}
         * @private
         */
        get: function () {
            if (this._config.isProductTypeSwitchVisible !== undefined)
                return this._config.isProductTypeSwitchVisible;
            else
                return this._config.isProductBusinessTypeSwitchVisible;
        },
        /**
         * @desc set visibility state for switch component
         * @param {Boolean} isVisible flag for switch visibility
         * @private
         */
        set: function (isVisible) {
            if (this._config.isProductTypeSwitchVisible !== undefined)
                this._config.isProductTypeSwitchVisible = isVisible;
            else
                this._config.isProductBusinessTypeSwitchVisible = isVisible;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @desc override for data preparation for swiper
     * @private
     * @override
     */
    BSSSwiperTabsProductTypeSwitch.prototype._prepareData = function () {
        _super.prototype._prepareData.call(this);
        this._prepareProductTypeSwitchInitData();
    };
    /**
     * @desc data preparation for product type switch
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._prepareProductTypeSwitchInitData = function () {
        var _a;
        var productTypeSwitchConfiguration = (this._config || {}).productTypeSwitchConfiguration;
        this._SWITCH_FLAG_NAME = 'switchedToBusiness';
        this._PRODUCT_TYPE_FLAG_NAME = 'isBusiness';
        this._BUSINNESS_TYPES = ['consumer', 'company'];
        this._TRIGGER_BASE_CLASS = 'bss-swiper-with-switch_trigger';
        this._TRIGGER_FIRST_LAST_CLASS = "".concat(this._TRIGGER_BASE_CLASS, "--first-and-last");
        this._TRIGGER_SECOND_CLASS = "".concat(this._TRIGGER_BASE_CLASS, "--second-element");
        this._productTypeSwitchContainerSelector = "#".concat((_a = productTypeSwitchConfiguration.containerId) !== null && _a !== void 0 ? _a : 'navigationTabs_product-type-switch');
        // class name for swiper wrapper added when switch is visible
        this._swiperTabsWrapperWithSwitchClassName =
            'bss-swiper-tabs-wrapper--product_type_switch';
        // product type switch configuration as array
        this._productTypeSwitchConfiguration = isEmpty(productTypeSwitchConfiguration)
            ? null
            : productTypeSwitchConfiguration;
        if (this._productTypeSwitchConfiguration.isIndependent) {
            return;
        }
        // set product switch visibiliy flag to config - for the use of .hbs
        this._config.isProductTypeSwitchVisible = this._checkSwitchVisibility();
        if (this._isProductTypeSwitchVisible) {
            // needed as early to set config for the use of _getActiveTabConfig override
            this._setGroupedActiveConfig();
        }
    };
    /**
     * @desc check product type switch visibility
     * @returns {Boolean} state whether product type switch is visible or not
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._checkSwitchVisibility = function () {
        if (this._productTypeSwitchConfiguration) {
            // check products flags - switch flags and product type flags
            var isProductsFlagsCoherent = this._validateSwitchVisibility();
            if (isProductsFlagsCoherent) {
                return true;
            }
            logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Product type switch can not be rendered"));
        }
        else {
            logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Product type switch can not be rendered - missing product type switch configuration"));
        }
        return false;
    };
    /**
     * @desc validate switch component visibility in relation to switch state flag and products' flags
     * @returns {Boolean} state if switch component is visible or not
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._validateSwitchVisibility = function () {
        var _this = this;
        var switchFlagValues = [];
        var productTypeFlagValues = [];
        var resultDataGrouped = { consumer: {}, company: {} };
        var resultData = cloneDeep(this._config.resultData);
        if ('general' in resultData) {
            delete resultData.general;
        }
        var resultDataValues = Object.values(resultData).filter(function (product) { return !product.error; });
        // filtering returns results for filtering but also prepares data for further validation and usage
        var resultDataWithCoherentFlags = resultDataValues.filter(function (product) {
            // read flag for switch component - state of switch component (if is switched to business products or not)
            var switchFlag = _this._convertToBoolean(product[_this._SWITCH_FLAG_NAME]);
            // read flag for product type - if a product is a business product or not
            var productTypeFlag = _this._convertToBoolean(product[_this._PRODUCT_TYPE_FLAG_NAME]);
            // switch flag is not undefined and has boolean value
            var isSwitchFlag = typeof switchFlag === 'boolean';
            // product type flag is not undefined and has boolean value
            var isProductTypeFlag = typeof productTypeFlag === 'boolean';
            if (isSwitchFlag) {
                switchFlagValues.push(switchFlag);
            }
            if (isProductTypeFlag) {
                var productId = product.productId;
                productTypeFlagValues.push(productTypeFlag);
                // if isSwitchedToBusiness is set to true
                if (productTypeFlag) {
                    resultDataGrouped.company[productId] = product;
                }
                else {
                    resultDataGrouped.consumer[productId] = product;
                }
            }
            return isSwitchFlag && isProductTypeFlag;
        });
        var isValid = this._validateSwitchAndProductFlags({
            resultDataWithCoherentFlags: resultDataWithCoherentFlags,
            resultDataValues: resultDataValues,
            productTypeFlagValues: productTypeFlagValues,
            switchFlagValues: switchFlagValues,
        });
        if (isValid) {
            this._isSwitchedToBusiness = switchFlagValues[0];
            this._resultDataGrouped = resultDataGrouped;
        }
        return isValid;
    };
    /**
     * @desc convert string boolean value to a real boolean
     * @returns {boolean | string} value
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._convertToBoolean = function (value) {
        switch (value) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return 'not a boolean flag';
        }
    };
    /**
     * @desc validate flags - switch state flags and products' flags
     * @returns {Boolean} state of validation
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._validateSwitchAndProductFlags = function (_a) {
        var _b = _a.resultDataWithCoherentFlags, resultDataWithCoherentFlags = _b === void 0 ? [] : _b, _c = _a.resultDataValues, resultDataValues = _c === void 0 ? [] : _c, _d = _a.productTypeFlagValues, productTypeFlagValues = _d === void 0 ? [] : _d, _e = _a.switchFlagValues, switchFlagValues = _e === void 0 ? [] : _e;
        // check if all products have switch flag and product type flag
        if (resultDataWithCoherentFlags.length !== resultDataValues.length) {
            logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Product type switch flag or product type is not present in all products"));
            return false;
        }
        // check if all products have product type flags with different values (so as there are consumer & business products)
        var isProductTypeFlagsWithDifferentValues = this._checkEveryValueInArray(productTypeFlagValues, [true, false]);
        if (!isProductTypeFlagsWithDifferentValues) {
            logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Products type flags have the same value in all products"));
            // set flag for recalculation according to one type of products type
            this._sendEventToUpdateSwitchFlagInRecalculation(productTypeFlagValues[0]);
            return false;
        }
        // check if all products have switch flag with consitent value: true or false, but the same in all products
        var isSwitchFlagsWithDifferentValues = this._checkEveryValueInArray(switchFlagValues, [true, false]);
        if (isSwitchFlagsWithDifferentValues) {
            logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Products type switch flags have incoherent values"));
            return false;
        }
        return true;
    };
    /**
     * @desc override for getting active slide index - when switch is visible, return a correct active tab index
     * from active tab config in relation to isSwitchedToBusiness flag
     * @param {String} tabId tab id
     * @returns {Number} active tab index
     * @private
     * @override
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getActiveSlideIndex = function (tabId) {
        // store original active tab index for all products visible (in case switch component is not visible/rendered) for edge case uses
        this._allProductsActiveTabIndex = _super.prototype._getActiveSlideIndex.call(this, tabId);
        if (this._isProductTypeSwitchVisible) {
            this._updateActiveTabConfig();
            return this._getActiveTabConfig().tabIndex;
        }
        return this._allProductsActiveTabIndex;
    };
    /**
     * @desc actions before swiper init
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._preInitSwiperActions = function () {
        if (this._isProductTypeSwitchVisible) {
            var isSwitchRendered = this._initSwitch();
            if (isSwitchRendered) {
                if (this._config.productTypeSwitchConfiguration.isIndependent) {
                    return;
                }
                this._setGroupedTriggersConfig();
                this._hideGroupedTriggers(this._getGroup({ data: this._$groupedTriggers, state: 'toHide' }));
                this._setTriggersSpacing();
                this._sendEventToUpdateSwitchFlagInRecalculation(this._isSwitchedToBusiness);
                // switch component was not rendered due to component errors
            }
            else {
                this._isProductTypeSwitchVisible = false;
            }
        }
    };
    /**
     * @desc override for init swiper
     * @private
     * @override
     */
    BSSSwiperTabsProductTypeSwitch.prototype._initSwiper = function () {
        this._preInitSwiperActions();
        _super.prototype._initSwiper.call(this);
        this._postInitSwiperActions();
        this._setActiveSlide(this._tabsContent, true);
    };
    /**
     * @desc actions after swiper init
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._postInitSwiperActions = function () {
        // if switch component was not rendered due to component errors or due to switch validation errors
        if (!this._isProductTypeSwitchVisible) {
            this._setActiveTabLogic(this._allProductsActiveTabIndex);
        }
    };
    /**
     * @desc init product type switch component
     * @returns {Boolean} state if switch component was rendered or not
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._initSwitch = function () {
        if (this._isProductTypeSwitchVisible) {
            this._productTypeSwitchConfiguration.checked = this._isSwitchedToBusiness;
            this._switchComponent = new BSSCheckboxProductTypeSwitchComponent(this._entityTemplate, this._productTypeSwitchContainerSelector, this._productTypeSwitchConfiguration, this._eventManager, this._formatter, this._resolution, this._toolbox, this._config.texts, this._config.entityInstanceId);
            var $productTypeSwitchEl = this._switchComponent._$componentEl;
            // if switch component was indeed rendered in html
            if ($productTypeSwitchEl === null || $productTypeSwitchEl === void 0 ? void 0 : $productTypeSwitchEl.length) {
                this._setSwitchDefaults();
                this._addSwitchListeners();
                this._hideIndependentSwitch();
                this._eventManager.subscribe("bss-tab-change-ended-".concat(this._config.entityInstanceId), this._hideIndependentSwitch.bind(this));
                return true;
            }
            else {
                this._cleanLayoutFromSwitch();
                logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Product type switch could not be rendered due to component errors"));
                return false;
            }
        }
        logger.error("SwiperTabsProductTypeSwitch: ".concat(this._config.componentId, " => Product type switch could not be rendered due to validation errors"));
        return false;
    };
    BSSSwiperTabsProductTypeSwitch.prototype._hideIndependentSwitch = function () {
        var _this = this;
        var _a, _b, _c;
        this._$globalTitle = this._$componentEl.find('.bss-global-switch-checkbox_title');
        if (this._productTypeSwitchConfiguration.isIndependent) {
            var easyMoveProductId = (_b = (_a = Object.values(this._toolbox.resultDataFlat)) === null || _a === void 0 ? void 0 : _a.find(function (x) {
                return x.productType === 'it_easy_move_toyota' ||
                    x.productType === 'it_easy_move_lexus';
            })) === null || _b === void 0 ? void 0 : _b.productId;
            var currentProductId = this._toolbox.currentProductId;
            var hasError = (_c = this._config.resultData[this._toolbox.currentProductId]) === null || _c === void 0 ? void 0 : _c.calculationError;
            if (hasError) {
                currentProductId = easyMoveProductId;
            }
            var switchedToBusiness = this._config.resultData[easyMoveProductId].switchedToBusiness;
            if (currentProductId !== easyMoveProductId) {
                this._switchComponent._$componentEl.addClass('hidden');
                this._hideGlobalTitle(false);
                this._switchComponent._removeGlobalIndicators();
                this._eventManager.subscribe("bss-entity-created-".concat(this._config.entityInstanceId), function () { return _this._switchComponent._removeGlobalIndicators(); }, this._subscrberId);
            }
            else {
                this._switchComponent._$componentEl.removeClass('hidden');
                this._hideGlobalTitle(switchedToBusiness === 'true');
                this._switchComponent._setState(switchedToBusiness === 'true', this._switchComponent._textsAdded);
            }
        }
    };
    /**
     * @desc get group of object data: company or consumer - based on isSwitchedToBusiness state
     * @param {Object} data data object
     * @param {String} state 'toHide' or 'toShow'- indicating which data group to take ('toHide' or 'toShow') based on current isSwitchedToBusiness flag
     * @returns {Object} group of object data: company or consumer
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getGroup = function (_a) {
        var data = _a.data, _b = _a.state, state = _b === void 0 ? 'toShow' : _b;
        var _c = data || {}, consumer = _c.consumer, company = _c.company;
        if (state === 'toHide') {
            return this._isSwitchedToBusiness ? consumer : company;
        }
        // state equals to 'toShow'
        return this._isSwitchedToBusiness ? company : consumer;
    };
    /**
     * @desc get active tab configuration object based on isSwitchedToBusiness flag
     * @param {Boolean} switchedToBusiness flag stating if products are switched to consumer or company products
     * @returns {Object} active tab configuration object
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getActiveTabConfig = function (switchedToBusiness) {
        if (switchedToBusiness === void 0) { switchedToBusiness = this._isSwitchedToBusiness; }
        if (this._config.productTypeSwitchConfiguration.isIndependent) {
            var tabIndex_1 = this._getTabIndex(this.activeTabId) || 0;
            return { productId: this.activeTabId, tabIndex: tabIndex_1 };
        }
        var _a = this._groupedActiveConfig || {}, consumer = _a.consumer, company = _a.company;
        var _b = switchedToBusiness ? company : consumer, productId = _b.productId, tabIndex = _b.tabIndex;
        return { productId: productId, tabIndex: tabIndex };
    };
    /**
     * @desc update groupded active data configuration for tabIndex when html is ready (tabs rendered)
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._updateActiveTabConfig = function () {
        if (this._config.productTypeSwitchConfiguration.isIndependent) {
            return;
        }
        var _a = this._groupedActiveConfig || {}, consumer = _a.consumer, company = _a.company;
        company.tabIndex = this._getTabIndex(company.productId);
        consumer.tabIndex = this._getTabIndex(consumer.productId);
    };
    /**
     * @desc get tab index for a given tab id (where tabId is a product id)
     * @param {String} tabId tab id
     * @returns {Number} tab index
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getTabIndex = function (tabId) {
        var _a;
        var componentId = this._config.componentId;
        var $tabContent = ((_a = this._$componentEl) === null || _a === void 0 ? void 0 : _a.find(".bss-swiper-tabs-content #".concat(componentId, "_tab-content-").concat(tabId))) || null;
        return ($tabContent === null || $tabContent === void 0 ? void 0 : $tabContent.length)
            ? parseInt($tabContent.attr('data-index'))
            : null;
    };
    /**
     * @desc set groupded active data configuration: active productId and its tabIndex, for consumer and company
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._setGroupedActiveConfig = function () {
        var _this = this;
        this._groupedActiveConfig = this._BUSINNESS_TYPES.reduce(function (acc, type) {
            acc[type] = { productId: null, tabIndex: null };
            var resultData = _this._resultDataGrouped[type];
            if (!isEmpty(resultData)) {
                // sort resultData poroduct ids to be able to pick the lowest 'position' for a product (for the first element in _getGroupFirstProductId fn)
                var sortedProductId = sortByPosition(resultData);
                // first try to her active product according to conditions of 'parse-request' file rules (prepareProducts fn)
                // if not found, take the first productId from sorted product ids according to 'parse-request' file rules
                var productId = _this._getGroupActiveProductId(resultData) ||
                    _this._getGroupFirstProductId(sortedProductId);
                acc[type] = { productId: productId, tabIndex: _this._getTabIndex(productId) };
            }
            return acc;
        }, {});
    };
    /**
     * @desc get active product id for resultData group based on prepareProducts conditions
     * @param {Object} resultData result data object
     * @returns {String} product id
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getGroupActiveProductId = function (resultData) {
        var _a;
        var activeTabId = (_a = Object.values(resultData).find(function (item) { return item.activeTabId; })) === null || _a === void 0 ? void 0 : _a.activeTabId;
        return activeTabId || prepareProducts(resultData).defaultProductId;
    };
    /**
     * @desc get first product id for resultData group
     * @param {Object} resultData result data object
     * @returns {String} product id
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getGroupFirstProductId = function (resultData) {
        return Object.values(resultData)[0];
    };
    /**
     * @desc set grouped tab triggers configuration: consumer and company
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._setGroupedTriggersConfig = function () {
        var _this = this;
        this._$groupedTriggers = this._BUSINNESS_TYPES.reduce(function ($groupedTriggers, type) {
            $groupedTriggers[type] = null;
            var resultDataGroupedPerBusinessType = _this._resultDataGrouped[type];
            var productIdsGroupedPerBusinessType = resultDataGroupedPerBusinessType &&
                Object.keys(resultDataGroupedPerBusinessType);
            if (productIdsGroupedPerBusinessType) {
                $groupedTriggers[type] = _this._getTriggersForProductIds(_this._triggerSlides, productIdsGroupedPerBusinessType);
            }
            return $groupedTriggers;
        }, {});
    };
    /**
     * @desc get tab triggers for given product ids
     * @returns {jQuery} tab triggers
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._getTriggersForProductIds = function (triggers, productIds) {
        var _this = this;
        return triggers.filter(function (i) {
            return productIds.includes(_this._toolbox.$(triggers[i]).attr('data-product'));
        });
    };
    /**
     * @desc hide triggers
     * @param {jQuery} $triggers triggers elements
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._hideGroupedTriggers = function ($triggers) {
        this._triggerSlides.removeClass(['is-hidden', 'is-active']);
        $triggers.addClass('is-hidden');
    };
    /**
     * @desc show all triggers
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._showAllTriggers = function () {
        this._triggerSlides.removeClass('is-hidden');
    };
    /**
     * @desc set special spacing for visible and hidden triggers when swith is visible (there are consumer & company products)
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._setTriggersSpacing = function () {
        var $triggersVisible = this._getGroup({
            data: this._$groupedTriggers,
            state: 'toShow',
        });
        this._removeTriggersSpacing();
        $triggersVisible.addClass(this._TRIGGER_BASE_CLASS);
        $triggersVisible.last().addClass(this._TRIGGER_FIRST_LAST_CLASS);
        $triggersVisible.first().addClass(this._TRIGGER_FIRST_LAST_CLASS);
        $triggersVisible.eq(1).addClass(this._TRIGGER_SECOND_CLASS);
    };
    /**
     * @desc remove special spacing for all triggers
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._removeTriggersSpacing = function () {
        this._triggerSlides.removeClass([
            this._TRIGGER_BASE_CLASS,
            this._TRIGGER_FIRST_LAST_CLASS,
            this._TRIGGER_SECOND_CLASS,
        ]);
    };
    /**
     * @desc clean layout from switch classes and switch empty switch container
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._cleanLayoutFromSwitch = function () {
        var $productTypeSwitchContainer = this._$componentEl.find(this._productTypeSwitchContainerSelector) || null;
        var $swiperTabsWrapperWithSwitch = this._$componentEl.find(".".concat(this._swiperTabsWrapperWithSwitchClassName)) || null;
        if ($productTypeSwitchContainer === null || $productTypeSwitchContainer === void 0 ? void 0 : $productTypeSwitchContainer.length) {
            // clear product type switch container for sure
            $productTypeSwitchContainer.html('');
        }
        if ($swiperTabsWrapperWithSwitch === null || $swiperTabsWrapperWithSwitch === void 0 ? void 0 : $swiperTabsWrapperWithSwitch.length) {
            // remove class for wrapper when switch is visibile
            $swiperTabsWrapperWithSwitch.removeClass(this._swiperTabsWrapperWithSwitchClassName);
        }
    };
    /**
     * @desc set switch component default varaiables
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._setSwitchDefaults = function () {
        this._$switchInput = this._switchComponent._$input;
    };
    /**
     * @desc add switch component listeners
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._addSwitchListeners = function () {
        var _this = this;
        var _a;
        if ((_a = this._$switchInput) === null || _a === void 0 ? void 0 : _a.length) {
            this._$switchInput.on("click.".concat(this._productTypeSwitchConfiguration.componentId), this._onSwitchClick.bind(this));
            this._eventManager.subscribe("bss-entity-error-".concat(this._config.entityInstanceId), function () {
                var switchedToBusiness = _this._config.resultData[_this._toolbox.currentProductId].switchedToBusiness;
                _this._switchComponent._setState(switchedToBusiness === 'true', _this._switchComponent._textsAdded);
                _this._hideGlobalTitle(switchedToBusiness === 'true');
            });
        }
    };
    /**
     * @desc on switch click actions
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._onSwitchClick = function () {
        var isIndependent = this._config.productTypeSwitchConfiguration.isIndependent;
        this._toggleSwitchFlag();
        if (!isIndependent) {
            this._sendEventToUpdateSwitchFlagInRecalculation(this._isSwitchedToBusiness);
            var $triggers = this._getGroup({
                data: this._$groupedTriggers,
                state: 'toHide',
            });
            var productId = this._getActiveTabConfig().productId;
            // this triggers tagging
            this._hideGroupedTriggers($triggers);
            this._setTriggersSpacing();
            var slide = this._triggerSlides.filter("[data-product=\"".concat(productId, "\"]"));
            slide.trigger("click.".concat(this._config.componentId));
            this._switchComponent._setState(this._isSwitchedToBusiness, this._switchComponent._textsAdded);
        }
        else {
            var data = this._config.resultData[this._toolbox.currentProductId];
            var switchedToBusiness = data.switchedToBusiness;
            switchedToBusiness = !(switchedToBusiness === 'true');
            this._hideGlobalTitle(switchedToBusiness);
            this._switchComponent._setState(switchedToBusiness, this._switchComponent._textsAdded);
            var output = {};
            output[this._toolbox.currentProductId] = {};
            output[this._toolbox.currentProductId].switchedToBusiness = "".concat(switchedToBusiness);
            output[this._toolbox.currentProductId].triggerName = 'switchedToBusiness';
            this._eventManager.publish("bss-component-changed-".concat(this._config.entityInstanceId), this._config.componentType + '-' + this._config.componentId, output);
        }
    };
    BSSSwiperTabsProductTypeSwitch.prototype._hideGlobalTitle = function (switchedToBusiness) {
        if (switchedToBusiness) {
            this._$globalTitle.removeClass('hidden');
        }
        else {
            this._$globalTitle.addClass('hidden');
        }
    };
    /**
     * @desc toggle switch component
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._toggleSwitchFlag = function () {
        this._isSwitchedToBusiness = !this._isSwitchedToBusiness;
    };
    /**
     * @desc send event for entity to add switch flag for recalculation
     * @emits {bss-recalculation-add-params-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._sendEventToUpdateSwitchFlagInRecalculation = function (switchedToBusiness) {
        var _a, _b;
        var data = {};
        // set boolean value as string to BE request - only for NC
        if (((_a = this._config.resultData[this._productId]) === null || _a === void 0 ? void 0 : _a.productType.substring(0, 2)) ===
            'uc' ||
            ((_b = this._config.resultData[this.activeTabId]) === null || _b === void 0 ? void 0 : _b.productType.substring(0, 2)) ===
                'uc') {
            data[this._SWITCH_FLAG_NAME] = switchedToBusiness;
        }
        else {
            data[this._SWITCH_FLAG_NAME] = switchedToBusiness.toString();
        }
        this._eventManager.publish("bss-recalculation-add-params-".concat(this._config.entityInstanceId), "".concat(this._config.componentType, "-").concat(this._config.componentId), data);
    };
    /**
     * @desc remove invalid products
     * @param {number[]} invalidSlidesIdx array of invalid slider indexes
     * @param {string[]} prodIds array of invalid products ids
     * @override
     */
    BSSSwiperTabsProductTypeSwitch.prototype._removeInvalidProducts = function (invalidSlidesIdx, prodIds) {
        _super.prototype._removeInvalidProducts.call(this, invalidSlidesIdx);
        if (this._isProductTypeSwitchVisible) {
            this._updateResultDataGrouped(prodIds);
            this._reorganizeProductTabsOnProductSwitchOff();
        }
    };
    /**
     * @desc reorganize products tabs logic on product switch off
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._reorganizeProductTabsOnProductSwitchOff = function () {
        var _a = this._resultDataGrouped || {}, company = _a.company, consumer = _a.consumer;
        this._setGroupedActiveConfig();
        this._setGroupedTriggersConfig();
        // if there are still company and consumer products - switch can still be visible, activate a new proper product
        if (!isEmpty(company) && !isEmpty(consumer)) {
            this._reorganizeGroupedProductTabsOnProductSwitchOff();
            // if there are no company or consumer products - remove switch component from view, show all products
        }
        else {
            this._reorganizeOneGroupProductTabsOnProductSwitchOff();
            var switchedToBusiness = Object.values(!isEmpty(company) ? company : consumer)[0].isBusiness;
            // set flag for recalculation according to one type of products type
            this._sendEventToUpdateSwitchFlagInRecalculation(switchedToBusiness);
        }
    };
    /**
     * @desc reorganize products tabs within groups (when there are still consumer & company products) on product switch off
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._reorganizeGroupedProductTabsOnProductSwitchOff = function () {
        var tabIndex = this._getActiveTabConfig().tabIndex;
        this._setActiveTabLogic(tabIndex);
        this._setTriggersSpacing();
    };
    /**
     * @desc reorganize products tabs within one group (when there are only consumer or company products) on product switch off
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._reorganizeOneGroupProductTabsOnProductSwitchOff = function () {
        var company = (this._resultDataGrouped || {}).company;
        // get avtive tab for company or consumer config - depending on which group is visible
        var tabIndex = !isEmpty(company)
            ? this._getActiveTabConfig(true).tabIndex
            : this._getActiveTabConfig(false).tabIndex;
        this._cleanLayoutFromSwitch();
        this._setActiveTabLogic(tabIndex);
        this._removeTriggersSpacing();
        this._showAllTriggers();
    };
    /**
     * @desc update grouped result data by removing switched off products from groups
     * @param {string[]} prodIds array of invalid products ids
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._updateResultDataGrouped = function (prodIds) {
        var _this = this;
        var reducedResultDataGrouped = this._BUSINNESS_TYPES.reduce(function (acc, type) {
            var resultDataPerType = _this._resultDataGrouped[type] || null;
            var productIds = (resultDataPerType && Object.keys(resultDataPerType)) || [];
            productIds.forEach(function (productId) {
                if (!prodIds.includes(productId)) {
                    if (isEmpty(acc[type])) {
                        acc[type] = {};
                    }
                    acc[type][productId] = _this._resultDataGrouped[type][productId];
                }
            });
            return acc;
        }, {});
        this._resultDataGrouped = reducedResultDataGrouped;
    };
    /**
     * @desc set active tab logic
     * @param {number} index tab index
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._setActiveTabLogic = function (index) {
        var tabIndex = parseInt(index) || 0;
        this._slideToActiveTab(tabIndex);
        // update top monthly payment value
        this._updateCurrent();
    };
    /**
     * @desc slide to active tab
     * @param {number} index tab index
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._slideToActiveTab = function (index) {
        var tabIndex = parseInt(index) || 0;
        // this triggers tab-change event which then forces setting a proper product active footer with save button
        if (!this.isNoTabsTriggers) {
            this._tabsTriggers.slideTo(tabIndex, 0);
        }
        this._tabsContent.slideTo(tabIndex, 0);
        //  initialSlide is used at the end of entity render in _onEntityCreated, where finally a proper tab is activated based on initialSlide
        this._config.contentSwiperConfiguration.initialSlide = tabIndex;
        this._tabsContent.activeIndex = tabIndex;
        this._tabsTriggers.activeIndex = tabIndex;
        this._currentSliderIndex = tabIndex;
        this._tabsContent.update();
        this._tabsTriggers.update();
        if (!this.isNoTabsTriggers) {
            this._setActiveSlide(this._tabsTriggers, true);
        }
        this._setActiveSlide(this._tabsContent, true);
    };
    /**
     * @desc check whether all elements in the array include values
     * @param {Array} arr array to check
     * @param {Array} values array of values to compare to
     * @returns {Boolean} state if array passed test
     * @private
     */
    BSSSwiperTabsProductTypeSwitch.prototype._checkEveryValueInArray = function (arr, values) {
        return values.every(function (value) { return arr.includes(value); });
    };
    return BSSSwiperTabsProductTypeSwitch;
}(BSSSwiperTabsAnimations));
export default BSSSwiperTabsProductTypeSwitch;
